/* eslint-disable @typescript-eslint/no-explicit-any */
import {clarityAvailable} from '@src/utility/logger/libs/clarity/misc'
import {ClarityWindow} from '@src/utility/logger/libs/clarity/type'
import {sentryCaptureMessageFiltered} from '@src/utility/sentry'

import packageInfo from '../../../../../package.json'
import {LoggerStrategyType, LoggerUser} from '../../strategy/type'

const isDeploy = ['stage', 'sandbox', 'production'].includes(import.meta.env.VITE_ENVIRONMENT ?? 'development')

export class ClarityInjector implements LoggerStrategyType {
  setUser(user: LoggerUser): void {
    try {
      if (!clarityAvailable() || !isDeploy) {
        return
      }

      if (!user.id) {
        return
      }

      const clarity = (window as ClarityWindow).clarity
      if (clarity) {
        clarity('identify', user.id)

        if (user.email) {
          clarity('set', 'email', user.email)
        }

        if (user.phone) {
          clarity('set', 'phone', user.phone)
        }

        if (user.displayName) {
          clarity('set', 'displayName', user.displayName)
        }
        if (user.username) {
          clarity('set', 'username', user.username)
        }
        if (user.name) {
          clarity('set', 'name', user.name)
        }

        if (user.provider) {
          clarity('set', 'provider', user.provider)
        }

        if (user.origin) {
          clarity('set', 'origin', user.origin)
        }

        clarity('set', 'friendlyName', user.email)
        clarity('set', 'projectName', packageInfo.name)
        clarity('set', 'projectVersion', packageInfo.version)
      }
    } catch (error) {
      sentryCaptureMessageFiltered(error as Error, 'Error setting Clarity user')
    }
  }
}
